export const COMMITTEE_TYPE_LABELS = {
  ST: "Standing",
  CW: "Committee of the Whole",
  AS: "Appropriations Subcommittee",
  JS: "Joint Standing",
  SS: "Standing Subcommittee",
  SE: "Select Standing",
  CC: "Conference",
  FC: "Free Conference",
  IC: "Interim",
  AC: "Administrative",
  SI: "Select Interim",
  JI: "Joint Interim Subcommittee",
  OC: "Other",
};
